import React, { useState, useEffect } from "react";
import "./ViewQuotationOrder.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Button, Navbar, Nav, Container, Row, Col, Card, Form, Dropdown, Alert, Table } from "react-bootstrap";
import Logo from "../src/Photos/eximtracfinallogo.png";
import Account from "../src/Photos/Account.png";
import * as XLSX from "xlsx";

import { hasAccess } from "../src/roleAccess.js";

function ViewQuotationOrder() {

    const scrollToTop = () => {
        window.scrollTo(0, 0); // Scroll to the top of the page
    };

    const navigate = useNavigate();

    const { userId, orderId } = useParams(); // Get UserID and OrderID from the URL


    // States for file inputs
    const [proformaInvoiceFile, setProformaInvoiceFile] = useState(null);
    const [shippingDocuments, setShippingDocuments] = useState([]);

    // States for text inputs
    const [shipmentStatus, setShipmentStatus] = useState("");
    const [blNumber, setBlNumber] = useState("");
    const [shippingLines, setShippingLines] = useState("");
    const [eta, setEta] = useState("");
    const [etd, setEtd] = useState("");
    const [ProformaInvoiceNumber, setProformaInvoiceNumber] = useState("");
    const [CommercialInvoiceNumber, setCommercialInvoiceNumber] = useState("");
    const [CommercialInvoiceDate, setCommercialInvoiceDate] = useState("");
    const [ProformaInvoiceDate, setProformaInvoiceDate] = useState("");
    const [DischargePort, setDischargePort] = useState("");
    const [FinalDestination, setFinalDestination] = useState("");
    const [ContainerNumber, setContainerNumber] = useState("");


    // States for success/error messages
    const [message, setMessage] = useState("");
    const [messageType, setMessageType] = useState(""); // "success" or "danger"

    // Handle file change
    const handleFileChange = (e, setFile) => {
        const files = Array.from(e.target.files); // Convert FileList to Array
        setFile(files);
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();

        // Append files
        if (proformaInvoiceFile?.[0]) formData.append("proformaFile", proformaInvoiceFile[0]);
        if (shippingDocuments?.length > 0) {
            for (let i = 0; i < shippingDocuments.length; i++) {
                formData.append("shippingDocuments", shippingDocuments[i]);
            }
        }

        // const userId = localStorage.getItem('userId');

        // Append other fields
        formData.append("OrderID", orderId); // Replace with dynamic OrderID
        formData.append("UserID", userId); // Replace with dynamic UserID
        formData.append("ShippingStatus", shipmentStatus);
        formData.append("BLNumber", blNumber);
        formData.append("ShippingLines", shippingLines);
        formData.append("ContainerNumber", ContainerNumber);
        formData.append("ETA", eta);
        formData.append("ETD", etd);
        formData.append("ProformaInvoiceNumber", ProformaInvoiceNumber)
        formData.append("CommercialInvoiceNumber", CommercialInvoiceNumber)
        formData.append("CommercialInvoiceDate", CommercialInvoiceDate)
        formData.append("ProformaInvoiceDate", ProformaInvoiceDate)
        formData.append("DischargePort", DischargePort)
        formData.append("FinalDestination", FinalDestination)



        try {
            const response = await fetch(`https://api-ft5g.onrender.com/upload-files-to-user/${orderId}/${userId}`, {
                method: "POST",
                body: formData,
            });

            if (response.ok) {
                const data = await response.json();
                console.log("Upload successful:", data);
                setMessage("Data has been successfully submitted!");
                setMessageType("success");
            } else {
                const error = await response.json();
                console.error("Error uploading files:", error);
                setMessage("File upload failed. Please try again.");
                setMessageType("danger");
            }
        } catch (err) {
            console.error("Network error:", err);
            setMessage("Network error. Please check your connection.");
            setMessageType("danger");
        }
    };


    // const navigate = useNavigate();
    const [userDetails, setUserDetails] = useState([]);

    useEffect(() => {
        // Adjust the API URL based on the backend route
        const url = orderId
            ? `https://api-ft5g.onrender.com/Get-Order-data-user-and-admin/${userId}/${orderId}`
            : `https://api-ft5g.onrender.com/Get-Order-data-user-and-admin/${userId}`;

        fetch(url)
            .then((res) => {
                if (!res.ok) {
                    throw new Error(`HTTP error! Status: ${res.status}`);
                }
                return res.json();
            })
            .then((data) => setUserDetails(data.data))
            .catch((err) => console.error("Error fetching data:", err));
    }, [orderId, userId]);




    const [fileData, setFileData] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchFileData = async () => {
            const token = localStorage.getItem("token");

            if (!userId || !token) {
                const errorMsg = "Missing required data: userId or token.";
                // setError(errorMsg);
                console.error(errorMsg);
                return;
            }

            try {
                const response = await fetch(
                    `https://api-ft5g.onrender.com/get-files-data/${userId}/${orderId}`,
                    {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                if (response.ok) {
                    const data = await response.json();
                    console.log("File Data Response:", data); // Debugging response
                    setFileData(data.files || []);
                } else {
                    // const errorMsg = `Failed to fetch file data: ${response.status} ${response.statusText}`;
                    throw new Error(`Failed to fetch file data: ${response.status}`);
                }
            } catch (err) {
                console.error("Error fetching file data:", err);
                setError([]); // Treat as no data
            }
        };

        fetchFileData();
    }, [userId, orderId]); // Add userId and orderId as dependencies


    const [shipmentData, setShipmentData] = useState([]);
    const [error2, setError2] = useState(null);

    useEffect(() => {
        if (!userId || !orderId) return;

        const fetchShipmentData = async () => {
            const token = localStorage.getItem("token");
            try {
                const response = await fetch(
                    `https://api-ft5g.onrender.com/get-shipment-details/${userId}/${orderId}`,
                    {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                if (!response.ok) {
                    throw new Error(`Failed to fetch shipment details: ${response.status}`);
                }

                const payload = await response.json();
                if (payload.success) {
                    // wrap the single shipment object in an array so .map() works
                    setShipmentData([payload.shipment]);
                } else {
                    setShipmentData([]);
                    setError2(payload.message);
                }
            } catch (err) {
                console.error("Error fetching shipment data:", err);
                setError2([]);
            }
        };

        fetchShipmentData();
    }, [userId, orderId]);


    const handleDownloadZip = async (userId, orderId) => {
        try {
            const response = await fetch(`https://api-ft5g.onrender.com/download-order-files-zip/${userId}/${orderId}`);

            if (!response.ok) {
                throw new Error('Failed to download zip');
            }

            const blob = await response.blob();

            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `Order_${orderId}_Files.zip`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error("Download ZIP failed", error);
        }
    };

    const handleDownloadFile = async (userId, orderId, fileName) => {
        try {
            const response = await fetch(`https://api-ft5g.onrender.com/download-single-file/${userId}/${orderId}/${encodeURIComponent(fileName)}`);

            if (!response.ok) {
                throw new Error('Failed to download file');
            }

            const blob = await response.blob();

            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error("Download individual file failed", error);
        }
    };


    const handleDeleteFile = async (userId, orderId, fileName) => {
        const confirmDelete = window.confirm(`Are you sure you want to delete "${fileName}"?`);

        if (!confirmDelete) return;

        try {
            const response = await fetch(`https://api-ft5g.onrender.com/delete-file/${userId}/${orderId}/${encodeURIComponent(fileName)}`, {
                method: 'DELETE'
            });

            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.message || "Failed to delete file");
            }

            alert("File deleted successfully");

            // Optional: Refresh file list or update UI accordingly
            // Example: re-fetch data
            // fetchFileData();

        } catch (error) {
            console.error("Delete file failed:", error);
            alert("Failed to delete file");
        }
    };



    const handleDownloadExcel = () => {
        if (userDetails.length === 0) {
            setMessage("No data available to download.");
            setMessageType("danger");
            return;
        }

        // Define mapping between keys in userDetails and labels for Excel
        const columnMap = [
            { key: "OrderID", label: "Order ID" },
            { key: "UploadDate", label: "Ordered On" },
            { key: "SKU_CODE", label: "SKU Code" },
            { key: "PRODUCT_DESCRIPTION", label: "Product Description" },
            // { key: "WEIGHT_PER_PKT_GRAMS", label: "Weight Per Packet (gm)" },
            { key: "UNIT_PER_CTN", label: "Quantity" },
            { key: "CartonQty", label: "No. of Cases" },
            { key: "TotalQty", label: "Total QTY" },
            { key: "RatePerUnitUSD", label: "Rate Per Unit USD" },
            { key: "RatePerCaseUSD", label: "Rate Per Case USD" },
            { key: "TotalRateInUSDFobIndia", label: "Total Rate In USD FOB INDIA" },
            { key: "TotalNetWeight", label: "Total Net Weight" },
        ];

        // Format data to match key order
        const formattedData = userDetails.map(item => {
            const reordered = {};
            columnMap.forEach(({ key, label }) => {
                reordered[label] = item[key] ?? "";
            });
            return reordered;
        });

        // Extract just the column labels for headers
        const headers = columnMap.map(col => col.label);

        // Create Excel worksheet
        const worksheet = XLSX.utils.json_to_sheet(formattedData, { header: headers });
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "EnquiryDetails");

        XLSX.writeFile(workbook, `Enquiry_Details_${new Date().toISOString()}.xlsx`);
    };


    const [user, setUser] = useState(null);

    useEffect(() => {
        fetch(`https://api-ft5g.onrender.com/user-by-order/${userId}/${orderId}`)
            .then(res => res.json())
            .then(data => setUser(data.user));
    }, [userId, orderId]);



    const totals = userDetails.reduce(
        (acc, item) => {
            acc.cases += parseFloat(item.CartonQty) || 0;
            acc.totalQty += parseFloat(item.TotalQty) || 0;
            acc.totalRate += parseFloat(item.TotalRateInUSDFobIndia) || 0;
            acc.totalWeight += parseFloat(item.TotalNetWeight) || 0;
            return acc;
        },
        { cases: 0, totalQty: 0, totalRate: 0, totalWeight: 0 }
    );


    const handleAdminRemarkChange = (index, value) => {
        setUserDetails(prev => {
            const updated = [...prev];
            updated[index] = { ...updated[index], AdminRemarks: value };
            return updated;
        });
    };


    const saveAdminRemarks = async () => {
        // const token = localStorage.getItem("token");

        try {
            const response = await fetch(
                `https://api-ft5g.onrender.com/save-admin-remarks/${orderId}`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        // Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        AdminRemarks: userDetails.map(item => ({
                            OID: item.OID, // or whatever uniquely identifies the row/item
                            AdminRemarks: item.AdminRemarks || ""
                        }))
                    }),
                }
            );

            const data = await response.json();
            if (data.success) {
                alert("Admin remarks saved successfully.");
            } else {
                alert("Failed to save remarks.");
            }
        } catch (err) {
            console.error("Save error:", err);
            alert("Something went wrong.");
        }
    };

    const handleLogout = () => {
        localStorage.clear();
        // Delay navigation slightly to ensure clear completes
        setTimeout(() => {
            navigate("/AdminLogin");
        }, 100); // 100ms is usually enough
    };


    const [unauthorized, setUnauthorized] = useState(false);

    useEffect(() => {
        if (!hasAccess("Order Update Page")) {
            setUnauthorized(true);

            // After 5 seconds, logout and redirect
            const timer = setTimeout(() => {
                localStorage.clear();
                navigate("/AdminLogin");
            }, 3000);

            return () => clearTimeout(timer); // cleanup
        }
    }, [navigate]);

    // ✅ Show unauthorized message if no access
    if (unauthorized) {
        return (
            <div style={{ padding: "2rem", textAlign: "center", color: "red" }}>
                <h2>🚫 Access Denied</h2>
                <p>You are not authorized to view this page.<br />You will be logged out in 3 seconds...</p>
            </div>
        );
    }


    return (
        <>
            <Navbar collapseOnSelect expand="lg" className="navibar" sticky="top">
                <Container>
                    {/* <Button onClick={scrollToTop} className="logoscrollbtn p-0"> */}
                    <Navbar.Brand href="/">
                        <img src={Logo}
                            alt="logo"
                            className="d-inline-block align-top logo" />
                    </Navbar.Brand>
                    {/* </Button> */}

                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />

                    <Navbar.Collapse id="responsive-navbar-nav">
                        {/* <Nav className="me-auto">
                                    </Nav> */}

                        <Nav>
                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Dashboard Page") && <Nav.Link as={Link} to="/AdminDash" className="adminnavtext">Dashboard</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Customers Page") && <Nav.Link as={Link} to="/Customers" className="adminnavtext">Customers</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Category Page") && <Nav.Link as={Link} to="/Category" className="adminnavtext">Category</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Sub - Category Page") && <Nav.Link as={Link} to="/SubCategory" className="adminnavtext">Sub-Category</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Brands Page") && <Nav.Link as={Link} to="/Brands" className="adminnavtext">Brands</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Products Page") && <Nav.Link as={Link} to="/AdminProducts" className="adminnavtext">Products</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Enquiry Page") && <Nav.Link as={Link} to="/Quotations" className="adminnavtext">Enquiries</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Order Page") && <Nav.Link as={Link} to="/AdminOrder" className="adminnavtext">Orders</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Contact Page") && <Nav.Link as={Link} to="/ContactUsResponse" className="adminnavtext">Contact</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Offline Order Page") && <Nav.Link as={Link} to="/OfflineOrder" className="adminnavtext">Offline Order</Nav.Link>}
                            </Button>

                            <Dropdown>
                                <Dropdown.Toggle className="scrollbtn3 p-0 mx-2 mt-1 responsiveview" id="dropdown-basic">
                                    <img src={Account}
                                        alt="account"
                                        className="d-inline-block align-top"
                                    />
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    {/* <Dropdown.Item href="/Profile">My Profile</Dropdown.Item> */}
                                    {/* <Dropdown.Item href="/OrderPage">Past Orders</Dropdown.Item> */}
                                    {hasAccess("Admin Permission Page") && <Dropdown.Item href="/AdminPermission">Admin Permission</Dropdown.Item>}
                                    <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </Nav>
                    </Navbar.Collapse>

                    <Dropdown>
                        <Dropdown.Toggle className="scrollbtn3 p-0 mx-2 mt-1 mobileview" id="dropdown-basic">
                            <img src={Account}
                                alt="account"
                                className="d-inline-block align-top"
                            />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            {/* <Dropdown.Item href="/Profile">My Profile</Dropdown.Item> */}
                            {/* <Dropdown.Item href="/OrderPage">Past Orders</Dropdown.Item> */}
                            {hasAccess("Admin Permission Page") && <Dropdown.Item href="/AdminPermission">Admin Permission</Dropdown.Item>}
                            <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    <Nav></Nav>
                    <Nav></Nav>
                    <Nav></Nav>
                    <Nav></Nav>
                    <Nav></Nav>
                    <Nav></Nav>
                </Container>
            </Navbar>

            {/* ----------------Navbar Complete---------------- */}

            <Container fluid className="">
                <Row className="border-top mt-3 py-2">
                    <Col>Name</Col>
                    <Col>Email</Col>
                    <Col>Company Name</Col>
                </Row>

                {/* Data Rows */}
                {user && (
                    <Row className="py-2 border-bottom">
                        <Col>{user.FirstName}</Col>
                        <Col>{user.EmailID}</Col>
                        <Col>{user.CompanyName}</Col>
                    </Row>
                )}

                <Row>
                    <Col className="mt-3 mb-3" lg={6}>
                        <Card>
                            <Form onSubmit={handleSubmit}>
                                {/* Display Success/Error Message */}
                                {message && (
                                    <Alert
                                        variant={messageType}
                                        className="mx-3 mt-3"
                                        onClose={() => setMessage("")}
                                        dismissible
                                    >
                                        {message}
                                    </Alert>
                                )}
                                {/* File Upload Fields */}

                                <Row>
                                    <Col className="mt-3 mx-3">
                                        <Form.Group controlId="formFileProforma" className="mb-3">
                                            <Form.Label>Upload Proforma Invoice</Form.Label>
                                            <Form.Control
                                                type="file"
                                                onChange={(e) => handleFileChange(e, setProformaInvoiceFile)}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col className="mx-3">
                                        <Form.Group controlId="formFileMultiple" className="mb-3">
                                            <Form.Label>Upload Shipping Documents</Form.Label>
                                            <Form.Control
                                                type="file"
                                                multiple
                                                onChange={(e) => handleFileChange(e, setShippingDocuments)}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col className="mt-3 mb-3 mx-3">
                                        <Button type="submit" className="adminproductsaddnewcatebtn w-100">
                                            Submit
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </Col>

                    <Col className="mt-3 mb-3" lg={6}>
                        <Card>
                            <Form onSubmit={handleSubmit}>
                                {/* Text Fields */}
                                <Row>
                                    <Col className="mt-2 mx-3">
                                        <Form.Label>Update Shipping Details</Form.Label>
                                        <Form.Select
                                            aria-label="Default select example"
                                            onChange={(e) => setShipmentStatus(e.target.value)}
                                            value={shipmentStatus}
                                        >
                                            <option value="">----Shipment Status----</option>
                                            <option value="Order Confirm">Order Confirm</option>
                                            <option value="Order In Process">Order In Process</option>
                                            <option value="In Transit">In Transit</option>
                                            <option value="Cargo Reached Destination Port">Cargo Reached</option>
                                        </Form.Select>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col className="mt-3 mx-3">
                                        <Form.Group className="mb-3" controlId="formGroupBLNo.">
                                            <Form.Label>BL Number</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Enter BL Number"
                                                value={blNumber}
                                                onChange={(e) => setBlNumber(e.target.value)}
                                            />
                                        </Form.Group>

                                        <Form.Group className="mb-3" controlId="">
                                            <Form.Label>Proforma Invoice Number</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Enter Proforma Invoice Number"
                                                value={ProformaInvoiceNumber}
                                                onChange={(e) => setProformaInvoiceNumber(e.target.value)}
                                            />
                                        </Form.Group>

                                        <Form.Group className="mb-3" controlId="formGroupPID">
                                            <Form.Label>Proforma Invoice Date</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Enter the Proforma Invoice Date DD/MM/YYYY"
                                                value={ProformaInvoiceDate}
                                                onChange={(e) => setProformaInvoiceDate(e.target.value)}
                                            />
                                        </Form.Group>

                                        <Form.Group className="mb-3" controlId="formGroupCIN">
                                            <Form.Label>Commercial Invoice Number</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Enter the Commercial Invoice Number"
                                                value={CommercialInvoiceNumber}
                                                onChange={(e) => setCommercialInvoiceNumber(e.target.value)}
                                            />
                                        </Form.Group>

                                        <Form.Group className="mb-3" controlId="formGroupCID">
                                            <Form.Label>Commercial Invoice Date</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Enter the Commercial Invoice Date DD/MM/YYYY"
                                                value={CommercialInvoiceDate}
                                                onChange={(e) => setCommercialInvoiceDate(e.target.value)}
                                            />
                                        </Form.Group>

                                        <Form.Group className="mb-3" controlId="formGroupShippingLines">
                                            <Form.Label>Shipping Lines</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Enter the Name of Shipping Lines"
                                                value={shippingLines}
                                                onChange={(e) => setShippingLines(e.target.value)}
                                            />
                                        </Form.Group>

                                        <Form.Group className="mb-3" controlId="">
                                            <Form.Label>Container Number</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Enter Container Number"
                                                value={ContainerNumber}
                                                onChange={(e) => setContainerNumber(e.target.value)}
                                            />
                                        </Form.Group>

                                        <Form.Group className="mb-3" controlId="formGroupETA">
                                            <Form.Label>Estimated Time of Arrival</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Enter the Estimated Time of Arrival"
                                                value={eta}
                                                onChange={(e) => setEta(e.target.value)}
                                            />
                                        </Form.Group>

                                        <Form.Group className="mb-3" controlId="formGroupETD">
                                            <Form.Label>Estimated Time of Departure</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Enter the Estimated Time of Departure"
                                                value={etd}
                                                onChange={(e) => setEtd(e.target.value)}
                                            />
                                        </Form.Group>

                                        <Form.Group className="mb-3" controlId="formGroupPID">
                                            <Form.Label>Discharge Port</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Enter the Discharge Port"
                                                value={DischargePort}
                                                onChange={(e) => setDischargePort(e.target.value)}
                                            />
                                        </Form.Group>

                                        <Form.Group className="mb-3" controlId="formGroupPID">
                                            <Form.Label>Final Destination</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Enter the Final Destination"
                                                value={FinalDestination}
                                                onChange={(e) => setFinalDestination(e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                {/* Submit Button */}
                                <Row>
                                    <Col className="mt-3 mb-3 mx-3">
                                        <Button type="submit" className="adminproductsaddnewcatebtn w-100">
                                            Submit
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </Col>
                </Row>

                <Row>
                    <Col className="mb-3 mt-3" lg={12} xs={12}>
                        <Card>
                            <h2 className="my-3">Shipment Details</h2>
                            {error2 && <p className="text-danger">Error: {error2}</p>}
                            <Table responsive striped bordered hover>
                                <thead>
                                    <tr>
                                        <th>Order ID</th>
                                        <th>Order Status</th>
                                        <th>Proforma Invoice Number</th>
                                        <th>Proforma Invoice Date</th>
                                        <th>Commercial Invoice Number</th>
                                        <th>Commercial Invoice Date</th>
                                        <th>Container Number</th>
                                        <th>Shipping Lines</th>
                                        <th>BL Number</th>
                                        <th>ETA</th>
                                        <th>ETD</th>
                                        <th>Discharge Port</th>
                                        <th>Final Destination</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {shipmentData.length === 0 ? (
                                        <p>No Shipment Data Available.</p>
                                    ) : (
                                        shipmentData.map((shipment, index) => (
                                            <tr key={index}>
                                                <td>{shipment.OrderID}</td>
                                                <td>{shipment.ShippingStatus}</td>
                                                <td>{shipment.ProformaInvoiceNumber}</td>
                                                <td>{shipment.ProformaInvoiceDate}</td>
                                                <td>{shipment.CommercialInvoiceNumber}</td>
                                                <td>{shipment.CommercialInvoiceDate}</td>
                                                <td>{shipment.ContainerNumber}</td>
                                                <td>{shipment.ShippingLines}</td>
                                                <td>{shipment.BLNumber}</td>
                                                <td>{shipment.ETA}</td>
                                                <td>{shipment.ETD}</td>
                                                <td>{shipment.DischargePort}</td>
                                                <td>{shipment.FinalDestination}</td>
                                            </tr>
                                        )
                                        ))}
                                </tbody>
                            </Table>
                        </Card>
                    </Col>
                </Row>

                <Row>
                    <Col className="mb-3 mt-3" lg={12} xs={12}>
                        <Card>
                            <h2 className="mb-0">Shipment Files</h2>

                            {error && <p className="text-danger">Error: {error}</p>}
                            <Table responsive striped bordered hover>
                                <thead>
                                    <tr>
                                        <th>Order ID</th>
                                        {/* <th>User ID</th> */}
                                        <th>Document Type</th>
                                        <th>File Name</th>
                                        {/* <th>File Type</th> */}
                                        <th>Upload Date</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {fileData.length === 0 ? (
                                        <p>No Shipment Data Available.</p>
                                    ) : (
                                        fileData.map((file, index) => (
                                            <tr key={index}>
                                                <td>{file.OrderID}</td>
                                                {/* <td>{file.UserID}</td> */}
                                                <td>{file.DocumentType}</td>
                                                <td>{file.FileName}</td>
                                                {/* <td>{file.FileType}</td> */}
                                                <td>{new Date(file.UploadDate).toLocaleDateString()}</td>
                                                <td>
                                                    <Button
                                                        variant="primary" className="mx-3 mt-2"
                                                        onClick={() => handleDownloadZip(file.UserID, file.OrderID)}
                                                    >
                                                        Download ZIP
                                                    </Button>

                                                    <Button
                                                        variant="success" className="mx-3 mt-2"
                                                        onClick={() => handleDownloadFile(file.UserID, file.OrderID, file.FileName)}
                                                    >
                                                        Download File
                                                    </Button>

                                                    <Button
                                                        variant="danger" className="mx-3 mt-2"
                                                        onClick={() => handleDeleteFile(file.UserID, file.OrderID, file.FileName)}
                                                    >
                                                        Delete
                                                    </Button>
                                                </td>
                                            </tr>
                                        )
                                        ))}
                                </tbody>
                            </Table>
                        </Card>
                    </Col>
                </Row>

                <Row>
                    {/* <Col lg={8} className="mt-3">
                        <Card className="p-4">
                            <h5 className="text-center mb-4">ORDER DETAILS</h5>

                            {
                                orderDetails.length > 0 ? (
                                    orderDetails.map((item, index) => (
                                        <Row key={index}>
                                            <hr className="mt-3 mb-3" />
                                            <Col>
                                                <Row className="text-center mb-2 mt-3">
                                                    <Col>
                                                        <p className="mb-1 text-muted orderfont2">{item.OrderID}</p>
                                                        <h4 className="orderfont1">{item.PRODUCT_DESCRIPTION}</h4>
                                                    </Col>
                                                    <Col>
                                                        <p className="text-muted mb-1 orderfont1">ORDERED ON</p>
                                                        <p className="orderfont1">{item.UploadDate}</p>
                                                    </Col>
                                                    <Col>
                                                        <p className="text-muted mb-1 orderfont1">STATUS</p>
                                                        <p className="text-warning orderfont1" style={{ fontWeight: "bold" }}>Ongoing</p>
                                                    </Col>
                                                </Row>

                                                <Row className="text-center">
                                                    <Col className="mt-4">
                                                        <p className="text-muted mb-1 orderfont1">QUANTITY</p>
                                                        <p className="orderfont1">{item.UNIT_PER_CTN} {item.UNIT} / CARTONS</p>
                                                    </Col>
                                                    <Col className="mt-4">
                                                        <p className="text-muted mb-1 orderfont1">NO. OF CARTONS</p>
                                                        <p className="orderfont1">{item.CartonQty}</p>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    ))
                                ) : (
                                    <p>No details available for this order.</p>
                                )
                            }

                            <hr className="my-4" />

                            <p className="text-center text-muted orderfont">
                                Your order will be delivered tentetively by <span style={{ fontWeight: "bold" }}>15 Dec 2024</span>
                            </p>

                            <hr />
                        </Card>
                    </Col> */}

                    <Col className="mt-3">
                        <Card className="p-4">
                            <Row>
                                <Col className="">
                                    <h4 className="mb-4">ORDER DETAILS</h4>
                                </Col>

                                <Col className="text-end">
                                    <Button className="mb-4 mx-2" onClick={handleDownloadExcel}>
                                        Download as Excel
                                    </Button>

                                    <Button onClick={saveAdminRemarks} className="mb-4" variant="success">
                                        Save Remarks
                                    </Button>

                                </Col>
                            </Row>

                            {userDetails.length > 0 ? (
                                <Table responsive bordered hover>
                                    <thead>
                                        <tr className="text-center">
                                            <th>OID</th>
                                            <th>Order ID</th>
                                            <th>Ordered On</th>
                                            <th>SKU Code</th>
                                            <th>Brand</th>
                                            <th>Product Description</th>
                                            {/* <th>Weight Per Packet (gm)</th> */}
                                            <th>Unit Size</th>
                                            <th>Unit Measurement Type</th>
                                            <th>Unit Per Case</th>
                                            <th>No. of Cases</th>
                                            <th>Total QTY</th>
                                            <th>Rate Per Unit (USD)</th>
                                            <th>Rate Per Case (USD)</th>
                                            <th>Total Rate FOB INDIA(USD)</th>
                                            <th>Total Weight</th>
                                            <th>User Remarks</th>
                                            <th>Admin Remarks</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {userDetails.map((item, index) => (
                                            <tr key={index} className="text-center">
                                                <td>{item.OID}</td>
                                                <td>{item.OrderID}</td>
                                                <td>{new Date(item.UploadDate).toLocaleDateString()}</td>
                                                <td>{item.SKU_CODE}</td>
                                                <td>{item.BRAND}</td>
                                                <td>{item.PRODUCT_DESCRIPTION}</td>
                                                {/* <td>{item.WEIGHT_PER_PKT_GRAMS}</td> */}
                                                <td>{item.UNIT_MEASUREMENT}</td>
                                                <td>{item.UNIT_MEASUREMENT_TYPE}</td>
                                                <td>{item.UNIT_PER_CTN} {item.UNIT}</td>
                                                <td>{item.CartonQty}</td>
                                                <td>{item.TotalQty}</td>
                                                <td>{Number(item.RatePerUnitUSD).toFixed(2)}</td>
                                                <td>{Number(item.RatePerCaseUSD).toFixed(2)}</td>
                                                <td>{Number(item.TotalRateInUSDFobIndia).toFixed(2)}</td>
                                                <td>{Number(item.TotalNetWeight).toFixed(2)}</td>
                                                <td>{item.UserRemarks}</td>
                                                <td>
                                                    <Form.Control
                                                        type="text"
                                                        value={item.AdminRemarks}
                                                        onChange={(e) => handleAdminRemarkChange(index, e.target.value)}
                                                        placeholder="Enter Admin Remark"
                                                    />
                                                    {item.AdminRemarks}
                                                </td>
                                            </tr>
                                        ))}

                                        <tr className="text-center">
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            {/* <td></td> */}
                                            <td>TOTAL</td>
                                            <td>{totals.cases}</td>
                                            <td>{totals.totalQty}</td>
                                            <td></td>
                                            <td></td>
                                            <td>{totals.totalRate.toFixed(2)}</td>
                                            <td>{totals.totalWeight.toFixed(2)}</td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                    </tbody>
                                </Table>
                            ) : (
                                <p className="text-center text-muted">No details available for this order.</p>
                            )}

                            {/* <hr className="my-4" />

                            <p className="text-center text-muted orderfont">
                                Your order will be delivered tentatively by <span style={{ fontWeight: "bold" }}>15 Dec 2024</span>
                            </p> */}
                        </Card>
                    </Col>
                </Row>
            </Container >
        </>
    );
}

export default ViewQuotationOrder;